export default __webpack_public_path__ + "static/media/parada_accessible_negatiu.d68ea291.png";